import { FC } from 'react';
import { CircularProgress, Stack } from '@mui/material';

export const AuthProgress: FC = () => {
	return (
		<Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ height: '100%' }}>
			<CircularProgress />
		</Stack>
	);
};
